import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CalendarComponentOptions, CalendarDay } from 'ion7-calendar';

type TSelectedDates = {
  from?: string | undefined;
  to?: string | undefined;
};

type TDateRange = { from: string | undefined; to: string | undefined };

@Component({
  selector: 'monorepo-ion-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnChanges {
  type!: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  @Input() dateRange!: TDateRange | string | undefined;

  @Input() options!: CalendarComponentOptions;
  @Input() selectedDates: TSelectedDates = {
    from: undefined,
    to: undefined,
  };
  // @Input() options: CalendarComponentOptions = {
  //   pickMode: 'range',
  //   weekStart: 1,
  //   from: new Date(),
  //   monthFormat: 'MMM YYYY',
  //   weekdays: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
  //   daysConfig: [
  //     {
  //       date: new Date(),
  //       marked: true,
  //       disable: false,
  //       subTitle: '8',
  //       cssClass: 'ion2-calendar__red-dot ion2-calendar__green-bg',
  //     },
  //   ],
  // };

  @Output() selectStart = new EventEmitter<CalendarDay>();
  @Output() selectEnd = new EventEmitter<CalendarDay>();
  @Output() targetDay = new EventEmitter<CalendarDay>();

  ngOnChanges(changes: SimpleChanges) {
    const selectedDates = changes['selectedDates']?.currentValue;
    if (selectedDates) {
      this.dateRange = {
        ...(this.dateRange as TDateRange),
        ...(selectedDates as TSelectedDates),
      };
    }
  }

  onSelectStart($event: CalendarDay) {
    console.log('selectStart ', $event);
    this.selectStart.emit($event);
  }

  onSelectEnd($event: CalendarDay) {
    console.log('selectEnd ', $event);
    this.selectEnd.emit($event);
  }

  onSelectedSingleDate($event: CalendarDay) {
    console.log('targetDay ', $event);
    this.targetDay.emit($event);
  }
}
